import React, { useContext } from 'react'
import { useMutation } from "@tanstack/react-query"
import { useCallback } from "react"
import { sendToAiMarkingFetch } from "store/middlewares/assessment.crud"
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { keys, map, pickBy } from 'lodash'
import { popupKeys, TranscriptionSystemContext } from '../../TranscriptionSystem'

const useHeaderActionBtns = (selectedAssessments, setSelectedAssessments) => {

    const { popups, setPopups } = useContext(TranscriptionSystemContext)

    const { } = useMutation({
        mutationFn: sendToAiMarkingFetch,
        onSuccess: () => {
            setSelectedAssessments([])
        }
    })

    const sendToAiMarking = useCallback((model) => {
        toast("נשלח להפעלת התהליך, את המבדקים המפוענחים ניתן נמצוא בטאב פוענח אוטומטי", toastConfig)
        const assessmentIDS = keys(pickBy(selectedAssessments, v => v === true));
        sendToAiMarkingFetch({ assessment_ids: assessmentIDS, model })
    }, [selectedAssessments])

    const createMarkingVersion = useCallback(() => {
        setPopups(popups => ({
            ...popups,
            [popupKeys.createVersion]: true
        }));
    }, [])

    const recalculateAssessmentReports = useCallback(() => {
        setPopups(popups => ({
            ...popups,
            [popupKeys.recalculateAssessment]: true
        }));
    }, [])


    const headerBtns = React.useMemo(
        () =>
            [
                // {
                //     label: "צור גרסא",
                //     action: createMarkingVersion
                // },
                // {
                //     label: "הפעל חישובי מבדקים מחדש",
                //     action: recalculateAssessmentReports
                // },
                {
                    label: "AI מודל 1",
                    action: () => sendToAiMarking(1)
                },
                {
                    label: "AI מודל 2",
                    action: () => sendToAiMarking(2)
                },
                {
                    label: "AI מודל 3",
                    action: () => sendToAiMarking(3)
                }
            ],
        [selectedAssessments]
    )

    return headerBtns
}

export default useHeaderActionBtns